import BaseModel from "nexia_mobile/models/base_model";

export default class Choice extends BaseModel {
  nestedCollections() {
    return { buttons: {} };
  }
}



// WEBPACK FOOTER //
// ./src/models/choice.js